import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import VMCohortDetails from './component';
import parseResponseToOptions, {
  parseUserListOptions,
  parseVMDetailsOptions
} from '../../utils/parseResponseToOptions';

const initialState = {
  loading: true,
  cohortDetails: {},
  cohortUserDetails: [],
  cohortVendingMachines: [],
  addVMModal: {
    showAddVMToCohortModal: false,
    loadingVMList: true,
    savingVMMappping: false,
    vmList: [],
    selectedVMs: []
  },
  addUserModal: {
    showAddUserToCohortModal: false,
    loadingUserList: true,
    savingUserMappping: false,
    userList: [],
    selectedUsers: []
  }
};

class DetailsOfCohortContainer extends Component {
  constructor() {
    super();
    this.state = initialState;
  }
  componentDidMount() {
    const { cohortId } = this.props.match.params;

    this.props.getDataFromAPI(
      `/vendingmachines/vm-cohorts?cohortId=${cohortId}`,
      'GET',
      undefined,
      response => {
        this.setState({
          cohortDetails: response.cohortDetails,
          cohortUserDetails: response.cohortUserDetails,
          cohortVendingMachines: response.cohortVendingMachines,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine cohort details');
        this.setState({ loading: false });
      }
    );
  }

  loadFreshData() {
    const { cohortId } = this.props.match.params;

    this.props.getDataFromAPI(
      `/vendingmachines/vm-cohorts?cohortId=${cohortId}`,
      'GET',
      undefined,
      response => {
        this.setState({
          ...initialState,
          cohortDetails: response.cohortDetails,
          cohortUserDetails: response.cohortUserDetails,
          cohortVendingMachines: response.cohortVendingMachines,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine cohort details');
        this.setState({ loading: false });
      }
    );
  }

  onDeleteOfUser = (name, userId, vmCohortId) => {
    if (!confirm(`Are you sure you want to remove "${name}"`)) {
      return;
    }
    // this.setState({ loading: true });

    if (!userId) {
      this.props.setLoading(false);
      return toastr.warning('Invalid', 'Invalid User Id');
    }
    this.props.getDataFromAPI(
      `/vendingmachines/vm-cohorts/${vmCohortId}/users/${userId}`,
      'DELETE',
      undefined,
      response => {
        this.loadFreshData();
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to remove vending machine');
        this.setState({ loading: false });
      }
    );
  };

  onDeleteOfVM = (vmId, vmCohortId) => {
    if (!confirm(`Are you sure you want to remove VM Id: ${vmId}?`)) {
      return;
    }
    // this.setState({ loading: true });

    if (!vmId) {
      this.props.setLoading(false);
      return toastr.warning('Invalid', 'Invalid VM Id');
    }
    this.props.getDataFromAPI(
      `/vendingmachines/vm-cohorts/${vmCohortId}/vendingmachines/${vmId}`,
      'DELETE',
      undefined,
      response => {
        this.loadFreshData();
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to remove vending machine');
        this.setState({ loading: false });
      }
    );
  };

  onClickOfAddVMToCohort = () => {
    this.setState((prevState, props) => {
      return { addVMModal: { ...prevState.addVMModal, showAddVMToCohortModal: true } };
    });
    this.props.getDataFromAPI(
      '/vendingmachines/su/all',
      'GET',
      undefined,
      response => {
        this.setState((prevState, props) => {
          return {
            addVMModal: {
              ...prevState.addVMModal,
              vmList: parseVMDetailsOptions(response.list),
              loadingVMList: false
            }
          };
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine list');
        this.setState((prevState, props) => {
          return {
            addVMModal: { ...prevState.addVMModal, loadingVMList: false }
          };
        });
      }
    );
  };

  onCloseOfAddVMModal = () => {
    this.setState((prevState, props) => {
      return { addVMModal: { ...prevState.addVMModal, showAddVMToCohortModal: false } };
    });
  };

  onSelectionOfVendingMachines = (event, data) => {
    this.setState((prevState, props) => {
      return {
        addVMModal: { ...prevState.addVMModal, selectedVMs: data.value }
      };
    });
  };

  onSaveOfVMMapping = () => {
    const payload = {
      cohortId: this.state.cohortDetails.id,
      vmCollection: this.state.addVMModal.selectedVMs
    };

    if (!payload.cohortId) {
      return toastr.warning('Invalid', 'Invalid Cohort Id, please refresh');
    }

    if (!payload.vmCollection || !payload.vmCollection.length) {
      return toastr.warning('Invalid', 'Please select VM(s) before saving');
    }

    this.props.getDataFromAPI(
      '/vendingmachines/vm-cohorts/mapping/vendingmachines',
      'POST',
      payload,
      response => {
        this.loadFreshData();
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine list');
        this.setState((prevState, props) => {
          return {
            addVMModal: { ...prevState.addVMModal, loadingVMList: false }
          };
        });
      }
    );
  };

  onClickOfAddUserToCohort = () => {
    this.setState((prevState, props) => {
      return { addUserModal: { ...prevState.addUserModal, showAddUserToCohortModal: true } };
    });

    this.props.getDataFromAPI(
      '/users/list',
      'GET',
      undefined,
      response => {
        this.setState((prevState, props) => {
          return {
            addUserModal: {
              ...prevState.addUserModal,
              userList: parseUserListOptions(response.list),
              loadingUserList: false
            }
          };
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch list of Users');
        this.setState((prevState, props) => {
          return {
            addUserModal: { ...prevState.addUserModal, loadingUserList: false }
          };
        });
      }
    );
  };

  onCloseOfAddUserModal = () => {
    this.setState((prevState, props) => {
      return { addUserModal: { ...prevState.addUserModal, showAddUserToCohortModal: false } };
    });
  };

  onSelectionOfUsers = (event, data) => {
    this.setState((prevState, props) => {
      return {
        addUserModal: { ...prevState.addUserModal, selectedUsers: data.value }
      };
    });
  };

  onSaveOfUserMapping = () => {
    const payload = {
      cohortId: this.state.cohortDetails.id,
      userIdCollection: this.state.addUserModal.selectedUsers
    };

    if (!payload.cohortId) {
      return toastr.warning('Invalid', 'Invalid Cohort Id, please refresh');
    }

    if (!payload.userIdCollection || !payload.userIdCollection.length) {
      return toastr.warning('Invalid', 'Please select User(s) before saving');
    }

    this.props.getDataFromAPI(
      '/vendingmachines/vm-cohorts/mapping/users',
      'POST',
      payload,
      response => {
        this.loadFreshData();
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to add user to the cohort');
        this.setState((prevState, props) => {
          return {
            addUserModal: { ...prevState.addUserModal, loadingUserList: false }
          };
        });
      }
    );
  };

  render() {
    return (
      <VMCohortDetails
        loading={this.state.loading}
        cohortDetails={this.state.cohortDetails}
        cohortUserDetails={this.state.cohortUserDetails}
        cohortVendingMachines={this.state.cohortVendingMachines}
        onDeleteOfUser={this.onDeleteOfUser}
        onDeleteOfVM={this.onDeleteOfVM}
        onClickOfAddUserToCohort={this.onClickOfAddUserToCohort}
        onClickOfAddVMToCohort={this.onClickOfAddVMToCohort}
        addVMModal={this.state.addVMModal}
        onSaveOfVMMapping={this.onSaveOfVMMapping}
        onSelectionOfVendingMachines={this.onSelectionOfVendingMachines}
        addUserModal={this.state.addUserModal}
        onCloseOfAddVMModal={this.onCloseOfAddVMModal}
        onCloseOfAddUserModal={this.onCloseOfAddUserModal}
        onSelectionOfUsers={this.onSelectionOfUsers}
        onSaveOfUserMapping={this.onSaveOfUserMapping}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(DetailsOfCohortContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMCohortDetails/container.jsx